import { Link } from "react-router-dom"
import { CoachTagWithImage } from "../../../models/public.interface"

export function CategorySlide({ id, name, image }: CoachTagWithImage) {
  return (
    <Link
      to={`/providers?tags=${id}`}
      className="group relative mr-4 block aspect-[7/6] shrink-0 grow-0 basis-[calc(50%-16px)] overflow-hidden rounded-xl sm:basis-[calc(33.33%-16px)] md:basis-[calc(25%-16px)] lg:basis-[calc(20%-16px)] xl:basis-[calc(16.66%-16px)]"
    >
      <img
        src={image}
        alt={`Find a coach in ${name}`}
        className="absolute inset-0 h-auto w-full transition-all group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-transparent"></div>
      <span className="sm:text-md absolute inset-x-3 inset-y-4 font-bold text-white sm:inset-x-5 sm:inset-y-4 md:text-lg">
        {name}
      </span>
    </Link>
  )
}
